import { CompanyModel } from '~models/company';

import { API } from './axios/instance';
import { CompanyInfoByNice } from '../types/company';
import { ResponseBase } from '../types/response';

interface Response extends ResponseBase {
  data: {
    items: CompanyInfoByNice[];
    current: number;
    hasNext: boolean;
  };
}

/**
 * NICE 기업조회
 * @param businessRegNo
 * @returns
 */
export default function getSearchCompany(request: CompanyModel.FindWorkspaceCompanyRequest) {
  return API.get<Response>(`/api/v2/companies/info`, { params: request });
}
